import React from 'react';

export type StandingRow = {
  rank: number;
  team: string;
  played: number;
  won: number;
  drawn: number;
  lost: number;
  pts: number;
  /** Goals for / against if you want to extend later */
  gf?: number;
  ga?: number;
};

type GroupStandingsTableProps = {
  groupLabel: string;
  rows: StandingRow[];
  caption?: string;
};

function GroupStandingsTable({ groupLabel, rows, caption }: GroupStandingsTableProps) {
  const showGd = rows.some((r) => r.gf !== undefined && r.ga !== undefined);

  return (
    <div className="wc26-table-scroll">
      <table className="wc26-table wc26-standings-table">
        <caption>
          {caption ?? `Group ${groupLabel}`}
        </caption>
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Team</th>
            <th scope="col">P</th>
            <th scope="col">W</th>
            <th scope="col">D</th>
            <th scope="col">L</th>
            {showGd ? (
              <>
                <th scope="col">GF</th>
                <th scope="col">GA</th>
                <th scope="col">GD</th>
              </>
            ) : null}
            <th scope="col">Pts</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const gd =
              r.gf !== undefined && r.ga !== undefined ? r.gf - r.ga : undefined;
            return (
              <tr key={r.team}>
                <td>{r.rank}</td>
                <th scope="row">{r.team}</th>
                <td>{r.played}</td>
                <td>{r.won}</td>
                <td>{r.drawn}</td>
                <td>{r.lost}</td>
                {showGd ? (
                  <>
                    <td>{r.gf}</td>
                    <td>{r.ga}</td>
                    <td>{gd !== undefined && gd > 0 ? `+${gd}` : gd}</td>
                  </>
                ) : null}
                <td className="wc26-standings-pts">{r.pts}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default GroupStandingsTable;
